import type { ReactNode } from "react";
import { useAuth } from "@repo/auth";
import { useVenue } from "./VenueContext";
import { canAccessVenue } from "./roles";
import type { MinRole } from "./roles";
import { Forbidden } from "../pages/Forbidden";

/**
 * ADVISORY route guard (features/roles-and-permissions.md R1/R2). Renders [children] only when the
 * caller's advisory claim role at the routed venue meets [minRole]; otherwise the 403 screen. This
 * is the ONLY place the shell makes a "decision", and it is purely presentational — the shell never
 * sends a role header and the server re-enforces every permission at action time. Nav entries declare
 * the SAME [minRole] and are filtered through the same `canAccessVenue`, so nav and guards can never
 * disagree.
 */
export function RequireVenueRole({ minRole, children }: { minRole: MinRole; children: ReactNode }) {
  const { venueId } = useVenue();
  const { claims } = useAuth();
  if (!canAccessVenue(claims, venueId, minRole)) return <Forbidden />;
  return <>{children}</>;
}
